export default __webpack_public_path__ + "static/media/certificate2Medium.220fd02c.webp";